var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 92,
    viewBox: "0 0 73 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2471 59.4461C54.2471 59.4461 53.4961 60.2621 52.4941 61.2401C51.5661 62.1451 51.2791 62.405 50.4171 63.246C49.9141 63.737 50.3281 64.188 51.2871 64.151C52.1301 64.118 54.0381 63.7081 55.1051 63.3251C55.8631 63.0531 57.2531 62.2841 57.9641 61.8351C58.6741 61.3861 58.8131 60.762 58.8131 60.762V59.2531L54.2471 59.4461Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9631 58.106C67.9631 58.106 67.4831 58.807 66.4801 59.784C65.5521 60.689 65.278 61.046 64.457 62.127C64.27 62.373 64.1601 63.078 65.1191 63.041C65.9621 63.008 67.245 62.65 68.314 62.269C69.534 61.835 70.5631 60.606 71.2731 60.157C71.9831 59.708 72.296 58.716 72.296 58.716L71.805 57.229L67.9631 58.106Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5801 33.623C67.9351 28.085 64.8821 25.175 64.8821 25.175C65.1251 23.309 56.4691 25.92 56.4691 25.92C56.4691 25.92 54.6161 35.952 53.8331 41.234C52.9431 47.237 53.4821 59.465 53.4821 59.465C53.4821 59.465 53.5941 60.77 55.8311 60.762C57.5471 60.755 58.8131 59.253 58.8131 59.253L58.9901 45.338L60.9781 35.47C60.9781 35.47 62.8921 43.49 63.4981 46.368C64.1431 49.43 66.6181 58.488 66.6181 58.488C66.6181 58.488 68.2201 60.328 70.2071 59.334C72.1951 58.34 71.8041 57.23 71.8041 57.23C71.8041 57.23 71.4141 50.805 68.8581 45.055C68.6451 40.687 67.4171 36.166 67.5801 33.623Z",
    fill: "#345F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6541 11.382C57.6541 11.382 56.4161 11.321 55.1381 13.722C53.8601 16.123 52.6381 18.679 52.6381 18.679C52.6381 18.679 54.4991 18.945 56.5221 20.809C59.2921 18.306 59.7441 12.551 57.6541 11.382Z",
    fill: "#345F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6541 11.382C57.6541 11.382 56.9571 12.717 56.3181 15.166C55.6791 17.615 55.9081 29.004 55.9081 29.004C55.9081 29.004 58.5471 30.87 62.9651 30.504C65.5921 30.287 66.9321 28.66 66.9321 28.66C66.9321 28.66 68.5031 17.508 68.2901 15.91C68.0771 14.313 64.7341 10.5599 64.7341 10.5599C64.7341 10.5599 60.3161 10.334 57.6541 11.382Z",
    fill: "#437CB2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6781 9.82498L60.1651 12.816C60.1651 12.816 61.6881 14.525 63.1791 13.247C64.6701 11.969 64.8831 11.381 64.8831 11.381L64.1491 7.30298L60.6781 9.82498Z",
    fill: "#FFAD97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3321 18.2959C61.3321 18.2959 63.2571 15.3999 64.7801 14.5879C66.3031 13.7759 67.1241 13.6249 67.1241 13.6249C67.1241 13.6249 66.5691 12.4789 66.1981 12.3469C65.5531 12.4439 65.1362 12.6209 63.7652 13.3319C62.3942 14.0429 60.8931 15.7659 60.2941 16.8239C59.0881 18.9529 60.4491 19.5249 61.3321 18.2959Z",
    fill: "#345F88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2441 11.122C58.2441 11.122 56.9891 14.113 56.8381 15.551C56.6871 16.989 56.9741 17.431 57.5521 17.482C58.1301 17.533 58.1621 16.507 58.3331 15.363C58.4951 14.282 59.5511 10.731 59.5511 10.731L58.2441 11.122Z",
    fill: "#345F88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1491 27.082C67.1491 27.082 65.7441 28.191 64.3541 28.038C63.1341 27.905 61.3791 26.718 61.4721 22.861C61.5651 19.003 61.9231 17.227 61.9231 17.227L57.2611 15.184C57.2611 15.184 55.9941 18.114 55.7441 23.863C55.4941 29.611 55.3891 31.593 55.3891 31.593C55.3891 31.593 60.3631 31.898 63.3081 31.593C66.2521 31.288 67.4831 30.924 67.4831 30.924L67.1491 27.082Z",
    fill: "#345F88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7751 16.24C57.7751 16.476 57.6431 16.668 57.4801 16.668C57.3171 16.668 57.1851 16.476 57.1851 16.24C57.1851 16.003 57.3171 15.812 57.4801 15.812C57.6431 15.812 57.7751 16.004 57.7751 16.24Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5681 17.543C60.4301 17.735 60.4251 17.968 60.5581 18.063C60.6901 18.158 60.9091 18.0789 61.0481 17.8869C61.1861 17.6949 61.1901 17.462 61.0581 17.367C60.9251 17.273 60.7061 17.351 60.5681 17.543Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8601 18.104C56.6701 19.068 56.7661 22.103 58.4851 22.56C60.0441 22.974 60.4471 21.136 60.8071 19.715C58.7881 19.257 56.8601 18.104 56.8601 18.104Z",
    fill: "#4680B6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7811 2.81396C61.5081 1.84396 58.4921 1.53296 57.3921 4.64896C56.2381 7.91596 59.1941 11.997 60.7701 11.304C61.6521 10.916 63.5081 9.53696 64.0301 7.81596C64.6191 5.87996 63.7711 3.56696 62.7811 2.81396Z",
    fill: "#FFC5B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6141 38.3801V26.5291L60.1641 21.7671V32.9471L50.6141 38.3801Z",
    fill: "#DBA763"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6141 38.3801V26.5291L41.0631 21.7671V32.9471L50.6141 38.3801Z",
    fill: "#E8B679"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6171 38.4821L50.6141 26.5291L60.1641 21.0071V32.9471L50.6171 38.4821Z",
    fill: "#DBA763"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6171 38.4821L50.6141 26.5291L41.0631 21.0071V32.9471L50.6171 38.4821Z",
    fill: "#E8B679"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0631 21.0071L50.6141 26.5291L60.1641 21.0071L50.6171 15.4871L41.0631 21.0071Z",
    fill: "#FFE1C0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6141 26.5371L54.4841 27.7731V24.2851L56.6141 23.0471V26.5371Z",
    fill: "#4D4D4D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6141 23.0471L47.0761 17.5331L44.9421 18.7671L54.4841 24.2891L56.6141 23.0471Z",
    fill: "#6D6D6D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8791 36.7711V36.1571L55.0851 34.2981V34.9211L51.8791 36.7711Z",
    fill: "#4D4D4D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8791 35.6731V35.0581L55.0851 33.1991V33.8221L51.8791 35.6731Z",
    fill: "#4D4D4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9641 31.1971V33.3291L59.4971 32.4411V30.3081L57.9641 31.1971Z",
    fill: "#4D4D4D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1641 30.9741V33.1961L41.6311 32.3101V30.0881L43.1641 30.9741Z",
    fill: "#4D4D4D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2571 32.187V34.409L43.7231 33.523V31.301L45.2571 32.187Z",
    fill: "#4D4D4D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7821 24.48V27.673L41.6311 25.852V22.655L44.7821 24.48Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3961 25.1331V24.6131L41.9171 23.1831V23.6951L44.3961 25.1331Z",
    fill: "#4D4D4D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5231 21.6961C62.5231 21.6961 60.7141 25.4991 59.9661 26.5591C59.2171 27.6191 56.1741 30.0411 55.5491 30.3931C54.9241 30.7451 53.4911 31.1921 52.7431 31.1211C51.9951 31.0501 51.4891 31.4161 52.2101 31.6891C52.9311 31.9621 53.6301 32.0261 53.6301 32.0261C53.6301 32.0261 52.3151 32.9981 51.7941 33.8271C51.3761 34.4931 51.0211 35.7181 52.6391 35.3631C53.9471 35.0761 55.7611 33.0721 56.2361 32.6271C57.1341 31.7851 60.7021 29.8551 61.5081 29.2841C62.6481 28.4771 65.8771 23.7191 65.8771 23.7191C65.8771 23.7191 64.8821 21.1951 62.5231 21.6961Z",
    fill: "#FFC5B3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7201 14.533C66.7821 13.778 64.7761 16.335 63.7111 17.933C62.6461 19.53 61.7931 21.921 61.7931 21.921C61.7931 21.921 63.0761 22.853 64.2241 23.577C65.1861 24.184 66.2041 24.644 66.2041 24.644C66.2041 24.644 70.9361 17.124 67.7201 14.533Z",
    fill: "#345F88"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1311 5.68705C57.6561 6.22205 58.4211 6.81705 60.0011 6.55705C61.2941 6.34405 62.2201 5.74105 62.2201 5.74105L62.4851 7.47205C62.4851 7.47205 62.7441 7.42505 62.9391 7.30505C62.9661 6.62005 63.2101 6.40705 63.5871 6.61105C64.0131 6.84205 64.0311 7.81805 64.0311 7.81805C64.0311 7.81805 65.3171 6.57605 64.8831 4.62305C64.6121 3.40605 62.9701 1.00205 60.6781 1.21505C58.3871 1.42805 57.0541 2.94205 56.7711 4.25305C56.6281 4.90905 56.8941 5.44505 57.1311 5.68705Z",
    fill: "#4D4D4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6681 4.18604C56.6681 4.18604 53.7251 6.25803 53.2181 6.69603C52.7111 7.13403 55.5451 9.04603 57.5511 8.40803C59.5581 7.76903 62.5771 5.53603 62.5771 5.53603L56.6681 4.18604Z",
    fill: "#0E6989"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6681 4.18598C56.6681 4.18598 60.0231 6.27098 62.1181 5.67398C64.2121 5.07598 64.7801 4.55598 64.7801 4.55598C64.7801 4.55598 64.5981 0.177979 60.7491 0.177979C56.9001 0.176979 56.6681 4.18598 56.6681 4.18598Z",
    fill: "#075277"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9211 0.319C60.9211 0.495 60.6621 0.638 60.3431 0.638C60.0241 0.638 59.7651 0.495 59.7651 0.319C59.7651 0.142 60.0241 0 60.3431 0C60.6621 0 60.9211 0.143 60.9211 0.319Z",
    fill: "#0E6989"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0111 67.806L34.2431 80.962L34.9531 81.408L57.7871 68.222L57.0111 67.806Z",
    fill: "#E06F22"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7871 68.22L34.9531 81.405V84.654L57.7871 71.469V68.22Z",
    fill: "#AF4C09"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2431 84.247V80.962L34.9531 81.405V84.654L34.2431 84.247Z",
    fill: "#C65C14"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5941 53.0651L8.82709 66.2201L9.53609 66.6671L32.3711 53.4801L31.5941 53.0651Z",
    fill: "#E06F22"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3711 53.478L9.53607 66.663V69.912L32.3711 56.727V53.478Z",
    fill: "#AF4C09"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82709 69.5051V66.2201L9.53609 66.6631V69.9121L8.82709 69.5051Z",
    fill: "#C65C14"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9341 60.072L21.1671 73.228L21.8761 73.674L44.7111 60.487L43.9341 60.072Z",
    fill: "#E06F22"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7111 60.486L21.8761 73.671V76.92L44.7111 63.735V60.486Z",
    fill: "#AF4C09"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1671 76.512V73.228L21.8761 73.671V76.92L21.1671 76.512Z",
    fill: "#C65C14"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9531 80.412L8.82709 65.327V66.378L34.9531 81.462V80.412Z",
    fill: "#C65C14"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6921 78.88L34.9531 80.412L8.82709 65.327L11.5521 63.796L37.6921 78.88Z",
    fill: "#E06F22"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6921 78.88L34.9531 80.412V82.37L37.6921 80.775V78.88Z",
    fill: "#AF4C09"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0481 77.409L13.8481 62.26V63.311L40.0481 78.46V77.409Z",
    fill: "#C65C14"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7871 75.878L40.0481 77.409L13.8481 62.26L16.5731 60.729L42.7871 75.878Z",
    fill: "#E06F22"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7871 75.8781L40.0481 77.409V79.3671L42.7871 77.773V75.8781Z",
    fill: "#AF4C09"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2651 74.453L19.0041 59.272V60.323L45.2651 75.504V74.453Z",
    fill: "#C65C14"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0041 72.921L45.2651 74.453L19.0041 59.272L21.7291 57.741L48.0041 72.921Z",
    fill: "#E06F22"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0041 72.921L45.2651 74.453V76.411L48.0041 74.817V72.921Z",
    fill: "#AF4C09"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3611 71.45L24.1611 56.366V57.416L50.3611 72.501V71.45Z",
    fill: "#C65C14"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1001 69.919L50.3611 71.45L24.1611 56.366L26.8851 54.835L53.1001 69.919Z",
    fill: "#E06F22"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1001 69.9189L50.3611 71.4499V73.4079L53.1001 71.8139V69.9189Z",
    fill: "#AF4C09"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0481 68.817L28.7861 53.667V54.717L55.0481 69.868V68.817Z",
    fill: "#C65C14"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7871 67.286L55.0481 68.817L28.7861 53.667L31.5101 52.135L57.7871 67.286Z",
    fill: "#E06F22"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7871 67.286L55.0481 68.817V70.775L57.7871 69.181V67.286Z",
    fill: "#AF4C09"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2941 71.7289L23.2991 63.5919L11.4941 56.7679V64.8879L23.2941 71.7289Z",
    fill: "#DBA763"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2941 71.729L23.2991 63.592L40.2881 53.776V61.896L23.2941 71.729Z",
    fill: "#E8B679"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2881 53.776L23.2991 63.592L11.4941 56.768L28.4891 46.955L40.2881 53.776Z",
    fill: "#FFE1C0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8831 63.6009L18.515 65.1289V60.8179L15.8831 59.2889V63.6009Z",
    fill: "#4D4D4D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8831 59.2889L32.861 49.4829L35.5 51.0079L18.515 60.8229L15.8831 59.2889Z",
    fill: "#6D6D6D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.414 70.381V69.622L18.451 67.324V68.094L22.414 70.381Z",
    fill: "#4D4D4D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.414 69.0229V68.2639L18.451 65.9659V66.7359L22.414 69.0229Z",
    fill: "#4D4D4D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M37.902 59.5829V62.3279L39.797 61.2329V58.4879L37.902 59.5829Z",
    fill: "#4D4D4D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M35.316 61.0819V63.8279L37.211 62.7329V59.9869L35.316 61.0819Z",
    fill: "#4D4D4D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M32.696 62.5869V65.3329L34.591 64.2379V61.4919L32.696 62.5869Z",
    fill: "#4D4D4D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.811 63.9289V67.8749L27.706 65.6249V61.674L23.811 63.9289Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.288 64.7359V64.0939L27.353 62.3269V62.9589L24.288 64.7359Z",
    fill: "#4D4D4D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2531 79.33L36.2571 71.193L24.4531 64.369V72.489L36.2531 79.33Z",
    fill: "#DBA763"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2531 79.3301L36.2571 71.1931L53.2471 61.3771V69.4971L36.2531 79.3301Z",
    fill: "#E8B679"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2471 61.377L36.2571 71.193L24.4531 64.369L41.4481 54.556L53.2471 61.377Z",
    fill: "#FFE1C0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M28.842 71.203L31.474 72.731V68.419L28.842 66.89V71.203Z",
    fill: "#4D4D4D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28.842 66.89L45.82 57.084L48.459 58.609L31.474 68.425L28.842 66.89Z",
    fill: "#6D6D6D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M35.373 77.9819V77.2229L31.41 74.9249V75.6949L35.373 77.9819Z",
    fill: "#4D4D4D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M35.373 76.624V75.865L31.41 73.567V74.337L35.373 76.624Z",
    fill: "#4D4D4D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M50.861 67.184V69.93L52.756 68.834V66.089L50.861 67.184Z",
    fill: "#4D4D4D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48.275 68.683V71.429L50.17 70.334V67.589L48.275 68.683Z",
    fill: "#4D4D4D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M45.655 70.188V72.934L47.55 71.839V69.094L45.655 70.188Z",
    fill: "#4D4D4D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M36.77 71.53V75.476L40.665 73.226V69.275L36.77 71.53Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2471 72.337V71.695L40.3111 69.928V70.56L37.2471 72.337Z",
    fill: "#4D4D4D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2941 62.752L23.2991 54.615L11.4941 47.792V55.912L23.2941 62.752Z",
    fill: "#DBA763"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2941 62.752L23.2991 54.615L40.2881 44.799V52.919L23.2941 62.752Z",
    fill: "#E8B679"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2881 44.799L23.2991 54.615L11.4941 47.791L28.4891 37.979L40.2881 44.799Z",
    fill: "#FFE1C0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8831 54.625L18.515 56.153V51.842L15.8831 50.312V54.625Z",
    fill: "#4D4D4D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8831 50.312L32.861 40.506L35.5 42.031L18.515 51.847L15.8831 50.312Z",
    fill: "#6D6D6D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22.414 61.4049V60.6449L18.451 58.3469V59.1169L22.414 61.4049Z",
    fill: "#4D4D4D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.414 60.047V59.287L18.451 56.989V57.76L22.414 60.047Z",
    fill: "#4D4D4D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M37.902 50.606V53.352L39.797 52.257V49.511L37.902 50.606Z",
    fill: "#4D4D4D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M35.316 52.106V54.852L37.211 53.757V51.011L35.316 52.106Z",
    fill: "#4D4D4D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M32.696 53.611V56.357L34.591 55.262V52.516L32.696 53.611Z",
    fill: "#4D4D4D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M23.811 54.953V58.899L27.706 56.648V52.697L23.811 54.953Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.288 55.76V55.117L27.353 53.35V53.982L24.288 55.76Z",
    fill: "#4D4D4D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2531 70.3529L36.2571 62.2169L24.4531 55.3929V63.5129L36.2531 70.3529Z",
    fill: "#DBA763"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2531 70.3529L36.2571 62.2169L53.2471 52.3999V60.5199L36.2531 70.3529Z",
    fill: "#E8B679"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2471 52.4L36.2571 62.216L24.4531 55.392L41.4481 45.58L53.2471 52.4Z",
    fill: "#FFE1C0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.842 62.226L31.474 63.754V59.443L28.842 57.913V62.226Z",
    fill: "#4D4D4D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M28.842 57.9129L45.82 48.1069L48.459 49.6329L31.474 59.4479L28.842 57.9129Z",
    fill: "#6D6D6D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M35.373 69.006V68.247L31.41 65.948V66.719L35.373 69.006Z",
    fill: "#4D4D4D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M35.373 67.648V66.889L31.41 64.59V65.361L35.373 67.648Z",
    fill: "#4D4D4D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M50.861 58.2069V60.9529L52.756 59.8579V57.1119L50.861 58.2069Z",
    fill: "#4D4D4D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M48.275 59.7069V62.4529L50.17 61.3579V58.6119L48.275 59.7069Z",
    fill: "#4D4D4D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M45.655 61.2119V63.9579L47.55 62.8629V60.1169L45.655 61.2119Z",
    fill: "#4D4D4D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M36.77 62.554V66.5L40.665 64.249V60.298L36.77 62.554Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2471 63.3609V62.7189L40.3111 60.9509V61.5829L37.2471 63.3609Z",
    fill: "#4D4D4D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8371 60.6219L35.8321 50.4159L50.6381 41.8569V52.0419L35.8371 60.6219Z",
    fill: "#DBA763"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8371 60.622L35.8321 50.416L14.5221 38.104V48.288L35.8371 60.622Z",
    fill: "#E8B679"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5221 38.104L35.8321 50.416L50.6381 41.8569L29.3221 29.549L14.5221 38.104Z",
    fill: "#FFE1C0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M45.133 50.428L41.832 52.345V46.937L45.133 45.019V50.428Z",
    fill: "#4D4D4D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1331 45.019L23.8381 32.719L20.5281 34.632L41.8321 46.944L45.1331 45.019Z",
    fill: "#6D6D6D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M36.941 58.9321V57.979L41.912 55.097V56.063L36.941 58.9321Z",
    fill: "#4D4D4D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.941 57.2279V56.2759L41.912 53.3929V54.3599L36.941 57.2279Z",
    fill: "#4D4D4D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5151 45.387V48.831L15.1381 47.458V44.014L17.5151 45.387Z",
    fill: "#4D4D4D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7591 47.268V50.713L18.3821 49.339V45.895L20.7591 47.268Z",
    fill: "#4D4D4D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0451 49.156V52.6L21.6681 51.227V47.783L24.0451 49.156Z",
    fill: "#4D4D4D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1891 50.839V55.789L30.3041 52.966V48.01L35.1891 50.839Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5911 51.851V51.046L30.7471 48.829V49.622L34.5911 51.851Z",
    fill: "#4D4D4D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3021 49.5501L19.2991 43.5761L28.8591 38.0491V44.0101L19.3021 49.5501Z",
    fill: "#DBA763"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3021 49.5501L19.2991 43.5761L5.53909 35.6261V41.5871L19.3021 49.5501Z",
    fill: "#E8B679"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53909 35.6361L19.2991 43.5861L28.8591 38.0601L15.0951 30.1121L5.53909 35.6361Z",
    fill: "#FFE1C0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0151 48.459V47.844L23.2241 45.983V46.607L20.0151 48.459Z",
    fill: "#4D4D4D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0151 47.3591V46.7441L23.2241 44.8831V45.5071L20.0151 47.3591Z",
    fill: "#4D4D4D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91609 38.0401V40.8141L6.0011 39.7071V36.9341L7.91609 38.0401Z",
    fill: "#4D4D4D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5291 39.5551V42.3291L8.61407 41.2231V38.4491L10.5291 39.5551Z",
    fill: "#4D4D4D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5501 44.208V47.519L13.6651 44.696V41.379L18.5501 44.208Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9521 45.22V44.414L14.1081 42.198V42.99L17.9521 45.22Z",
    fill: "#4D4D4D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4431 42.5881L23.1411 44.5051V41.3631L26.4431 39.4451V42.5881Z",
    fill: "#4D4D4D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4431 39.4451L12.7011 31.4971L9.3801 33.4161L23.1411 41.3701L26.4431 39.4451Z",
    fill: "#6D6D6D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62409 45.075C5.41609 42.383 5.82209 39.419 4.48309 37.241L1.57209 37.309C1.57209 37.309 0.398095 39.865 0.0960946 41.772C-0.205905 43.68 0.23409 44.588 0.99409 45.491C1.75409 46.395 4.45708 45.189 4.55808 45.122C4.56208 45.12 4.59709 45.095 4.62409 45.075Z",
    fill: "#FFC5B3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5931 86.8621C12.5931 86.8621 15.7191 85.4691 17.2651 85.4021C18.8121 85.3351 18.9611 87.1521 17.2651 88.5601C15.5691 89.9681 14.2701 90.1561 12.8821 90.7271C11.6311 91.2411 11.1821 91.2811 10.1841 90.6341C8.8521 89.7711 9.9191 87.4871 9.9191 87.4871L12.5931 86.8621Z",
    fill: "#4D4D4D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55409 81.5061C3.55409 81.5061 6.03709 80.4691 7.58309 80.4021C9.13009 80.3351 9.68409 81.6721 7.98809 83.0801C6.29209 84.4881 5.23109 84.8001 3.84309 85.3711C2.59209 85.8851 2.15009 85.9151 1.14509 85.2781C-0.222911 84.4101 0.84609 82.1271 0.88009 82.1311L3.55409 81.5061Z",
    fill: "#4D4D4D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7901 50.7091C12.7901 50.7091 15.5191 65.4481 15.5191 70.0781C15.5191 78.2401 15.4471 86.8351 15.4471 86.8351C15.4471 86.8351 14.0941 88.2551 12.7781 88.2591C9.81511 88.2671 9.51611 86.7761 9.51611 86.7761C9.51611 86.7761 9.47511 77.0491 9.21611 72.6301C9.03611 69.5561 8.85712 65.2251 7.62212 61.6531C7.58612 65.3221 7.5961 66.4981 7.2951 70.4931C7.0731 73.4401 5.84511 81.3511 5.77811 81.8661C4.83911 83.0001 1.92711 83.7841 0.451111 82.1231C0.566111 80.8211 1.38611 71.6831 1.27911 66.9451C1.18111 62.5921 0.0711043 52.2831 2.5601 50.2751C4.7101 48.5391 12.7901 50.7091 12.7901 50.7091Z",
    fill: "#345F88"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2531 41.318C5.1191 39.147 4.7831 37.878 4.7831 37.878L6.2341 33.264C6.2341 33.264 4.2011 32.233 2.8261 33.872C2.2541 34.553 1.2041 36.601 0.2901 38.511C0.9941 39.734 2.9091 41.395 5.2531 41.318Z",
    fill: "#345F88"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30509 24.2181C8.21809 23.4631 6.12709 23.6991 5.22009 25.6151C4.71809 26.6761 5.42709 29.5291 5.54009 31.5321C5.63009 33.1471 5.08909 34.0801 5.08909 34.0801C5.08909 34.0801 5.08909 34.0801 6.47509 34.6511C7.86109 35.2221 9.30509 34.6511 9.30509 34.6511L9.2601 32.1871C9.2601 32.1871 10.7521 31.9651 11.0131 31.7261C11.6421 31.1501 11.9741 29.4361 11.6831 27.2251C11.2491 23.9361 9.70509 24.4961 9.30509 24.2181Z",
    fill: "#FFC5B3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0441 41.899C13.8621 40.153 12.0081 36.985 11.4871 35.846C10.9671 34.707 9.30207 34.014 9.30207 34.014C9.30207 34.014 7.02707 33.19 6.23307 33.07C5.88707 33.018 4.68807 32.943 4.68807 32.943C4.68807 32.943 2.04108 37.107 1.74708 39.4C1.54108 41.006 2.41707 46.257 1.76807 51.427C1.42407 54.163 11.7491 53.392 12.6591 52.276C12.1311 49.69 11.3731 45.467 13.0441 41.899Z",
    fill: "#437DB5"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86511 43.024C1.87011 43.295 2.04511 46.47 1.71611 48.531C1.38711 50.592 1.18811 53.781 1.18811 53.781C1.18811 53.781 4.12411 56.065 7.51411 55.669C10.9051 55.272 13.2531 53.298 13.2531 53.298C13.2531 53.298 12.1261 47.496 12.1901 46.784C12.2541 46.072 12.2541 46.072 12.2541 46.072C12.2541 46.072 10.9531 46.688 10.1301 46.342C9.30711 45.997 7.93111 45.365 7.51511 43.266C7.21911 41.774 7.41311 38.304 7.48311 37.377C7.31611 37.353 3.10512 36.115 3.10512 36.115C3.10512 36.115 1.81611 40.223 1.86511 43.024Z",
    fill: "#345F88"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6481 28.096C10.8131 27.544 11.1901 26.262 11.2851 25.746C11.3951 25.146 11.4271 24.255 10.6081 23.403C9.78809 22.551 6.94709 22.276 5.91909 22.871C4.89109 23.466 2.70509 24.552 3.46809 28.096C4.08509 30.961 4.68409 31.282 5.55009 31.955C6.30609 32.543 7.63809 32.689 7.63809 32.689C7.63809 32.689 8.3801 32.152 8.5141 31.067C8.5561 30.725 8.5141 29.689 8.5141 29.689C8.5141 29.689 7.75709 28.191 8.34309 27.657C8.96809 27.088 9.60709 27.992 9.75309 28.358C10.2631 29.638 10.7721 30.24 10.6481 28.096Z",
    fill: "#4D4D4D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4921 46.201C24.4921 46.201 21.4941 46.388 18.4821 45.573C16.4841 45.032 15.4141 44.366 14.7091 44.019C14.3211 43.337 13.6161 41.198 13.6161 41.198L9.8251 42.744C9.8251 42.744 10.7811 45.303 11.3411 46.47C11.7921 47.408 12.3551 47.596 13.2531 47.927C14.5661 48.411 18.4151 48.544 19.9471 48.742C21.4791 48.94 22.4531 48.772 23.3271 48.561C25.1831 48.113 24.5661 46.715 24.4921 46.201Z",
    fill: "#FFC5B3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81611 43.9C11.6161 44.286 13.5601 43.727 14.5661 42.354C13.8331 39.039 12.6671 35.434 11.0691 34.905C10.2101 34.62 8.6731 37.597 8.9341 39.706C9.0081 40.301 9.36811 41.961 9.81611 43.9Z",
    fill: "#345F88"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42508 50.9291L1.29108 52.3851C1.29108 52.3851 3.26108 54.0791 7.51508 54.1751C11.7691 54.2711 13.1571 52.8171 13.1571 52.8171L12.9061 51.3191C12.9061 51.3191 10.7151 52.7031 7.39609 52.7531C4.07709 52.8031 1.42508 50.9291 1.42508 50.9291Z",
    fill: "#1A8AA8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2341 37.822C6.2341 37.822 6.7041 35.927 7.5891 35.015C8.4161 34.164 9.3031 34.015 9.3031 34.015C9.3031 34.015 10.1731 34.258 10.1611 34.504C9.6861 34.788 8.8171 35.108 8.3031 35.981C7.7901 36.855 7.40709 38.686 7.40709 38.686L6.2341 37.822Z",
    fill: "#345F88"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52608 32.944C4.48008 32.963 3.70808 34.119 3.14308 35.982C2.89108 36.812 2.61908 38.687 2.61908 38.687L3.44008 38.79C3.44008 38.79 4.22809 35.741 4.67409 34.641C5.12009 33.54 5.44708 32.998 5.44708 32.998L4.52608 32.944Z",
    fill: "#345F88"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3571 46.6381C22.4461 46.5961 23.4281 45.7041 23.7851 45.2881C24.1421 44.8721 24.4391 44.9761 24.3201 45.4441C24.2011 45.9121 23.5761 46.7151 23.5761 46.7151C23.5761 46.7151 22.6681 46.6381 22.5121 46.6381H22.3571Z",
    fill: "#FFC5B3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2751 23.487C11.3511 23.705 12.1721 25.067 11.1101 26.529C10.0481 27.991 7.50509 29 5.42909 28.782C3.35409 28.564 2.5321 27.202 3.5941 25.74C4.6561 24.278 7.2001 23.27 9.2751 23.487Z",
    fill: "#075277"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19411 27.399C3.19411 27.399 1.96012 23.188 5.70112 21.918C8.38912 21.005 10.4111 22.07 11.5011 24.83C12.1661 26.512 3.19411 27.399 3.19411 27.399Z",
    fill: "#075277"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0341 27.551C10.3071 27.398 11.5751 25.806 11.2231 24.358C11.1731 24.151 10.7021 23.331 10.7021 23.331C10.7021 23.331 11.0771 23.133 12.6171 23.458C14.1571 23.783 14.4441 25.166 13.2491 26.135C11.7321 27.367 10.0341 27.551 10.0341 27.551Z",
    fill: "#0E6989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/Accepted.bb28aa56c7935bb7a35ef0531bf93f78.svg";
export { ForwardRef as ReactComponent };